import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth';
import { ApiService } from '../api';
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  {
  constructor(private router: Router, private auth: AuthService, private api: ApiService) {}

  canActivate(from, to): boolean {
    let isAuthenticated = this.auth.isAuthenticated();
    let isLoggedin = this.api.isLoggedin;
    let userData = this.api.userData;

    if (to.url.includes('/home')) {
      if (userData) {
        if (userData.new_username?.length === 6 && userData.new_username?.match(/^-?\d+$/)) {
          this.router.navigateByUrl('/dashboard/kiosk');
          return false;
        }
      }
    }

    //ALLOW ACCESS to @CERTIFY ACCOUNTS

    if (to.url.includes('/compliance-tasks')) {
      if (!userData.emailaddress1.includes('certify.net.au')) {
        this.router.navigateByUrl('/dashboard');
        return false;
      }
    }

    //ALLOW Access to SUBCONTRACTORS and PRINCIPAL SUBCONTRACTORS

    if (['/employees', '/employees-menu'].some(path => to.url.includes(path))) {
      if (userData.customertypecode === Number(environment.role1)) {
        this.router.navigateByUrl('/dashboard');
        return false;
      }
    }

    if (['/risk-assessments', '/connect-employees'].some(path => to.url.includes(path))) {
      if (userData.customertypecode === Number(environment.role1)) {
        this.router.navigateByUrl('/dashboard');
        return false;
      }
    }

    if (to.url.includes('/new-inspection')) {
      if (userData.customertypecode === Number(environment.role1)) {
        this.router.navigateByUrl('/dashboard');
        return false;
      }
    }

    if (to.url.includes('/add-employee')) {
      if (userData.customertypecode === Number(environment.role1)) {
        this.router.navigateByUrl('/dashboard');
        return false;
      }
    }

    if (to.url.includes('/site-inductions')) {
      if (userData.customertypecode === Number(environment.role1)) {
        this.router.navigateByUrl('/dashboard');
        return false;
      }
    }

    if (to.url.includes('/export-records')) {
      if (userData.customertypecode === Number(environment.role1)) {
        console.log('XXX');
        this.router.navigateByUrl('/dashboard');
        return false;
      }
    }

    //ALLOW Access to PRINCIPAL SUBCONTRACTORS only (Number(environment.role2))

    if (to.url.includes('/subcontractors-menu')) {
      if (userData.customertypecode !== Number(environment.role2)) {
        this.router.navigateByUrl('/dashboard');
        return false;
      }
    }

    if (to.url.includes('/subcontractors/compliance')) {
      if (userData.customertypecode !== Number(environment.role2)) {
        this.router.navigateByUrl('/dashboard');
        return false;
      }
    }

    if (to.url.includes('/request-subcontractor')) {
      if (userData.customertypecode !== Number(environment.role2)) {
        this.router.navigateByUrl('/dashboard');
        return false;
      }
    }

    if (to.url.includes('/sites')) {
      if (userData.customertypecode !== Number(environment.role2)) {
        this.router.navigateByUrl('/dashboard');
        return false;
      }
    }

    if (to.url.includes('/sites-menu')) {
      if (userData.customertypecode !== Number(environment.role2)) {
        this.router.navigateByUrl('/dashboard');
        return false;
      }
    }

    if (to.url.includes('/site-inspections')) {
      if (userData.customertypecode !== Number(environment.role2)) {
        this.router.navigateByUrl('/dashboard');
        return false;
      }
    }

    if (to.url.includes('/site-subcontractors')) {
      if (userData.customertypecode !== Number(environment.role2)) {
        this.router.navigateByUrl('/dashboard');
        return false;
      }
    }

    if (to.url.includes('/site-message')) {
      if (userData.customertypecode !== Number(environment.role2)) {
        this.router.navigateByUrl('/dashboard');
        return false;
      }
    }

    if (to.url.includes('/add-project')) {
      if (userData.customertypecode !== Number(environment.role2)) {
        console.log('XXX');
        this.router.navigateByUrl('/dashboard');
        return false;
      }
    }

    //LOGIN AUTH
    if (to.url.includes('/login')) {
      if (isAuthenticated && isLoggedin) {
        this.router.navigateByUrl('/dashboard');
      }
      return !isAuthenticated || !isLoggedin;
    } else if (to.url.includes('/tabs') || to.url.includes('/dashboard')) {
      if (!isAuthenticated || !isLoggedin) {
        this.router.navigateByUrl('/login');
      }
      console.log('isAuthenticated', isAuthenticated);
      console.log('isLoggedin', isLoggedin);
      return isAuthenticated && isLoggedin;
    }

    return true;
  }
}
